module.exports = __webpack_public_path__ + "static/media/fxrp.64.d2dcea6d.webp";